(function() {
    'use strict';

    angular
        .module('atheer.airform', [

        ]);
})();
